import { Link } from "@tanstack/react-router"
import { cn } from "@/lib/utils"

type BrandMarkProps = {
  className?: string
}

export function BrandMark({ className }: BrandMarkProps) {
  return (
    <Link
      to="/"
      aria-label="एक्लो EKLO-Verse — home"
      className={cn(
        "flex h-11 items-center gap-3 px-4 text-white/90 transition-colors hover:text-brand sm:px-2",
        className
      )}
    >
      <span className="relative inline-block pt-1 pr-1 font-devanagari text-lg normal-case leading-none sm:text-xl">
        एक्लो
      </span>
      <span aria-hidden="true" className="h-4 w-px bg-white/20" />
      <span className="font-medium font-mono text-[13px] uppercase tracking-[0.28em] sm:text-[15px]">
        EKLO-Verse
      </span>
    </Link>
  )
}
